<template>
  <div class="third">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">校友圈公约配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="Reset()" class="btn-two" type="default">重置</el-button>
          <el-button
            @click="updateAlumniContractFN()"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
          >保存</el-button>
        </div>
      </div>
      <el-form  style="width:60%; float:left" :show-message="false" label-width="86px">
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <!-- <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>-->
            <div class="one-list">
              <el-form label-width="100px">
                <div class="list-two-line">
                  <el-form-item label="校友圈公约" class="required">
                    <el-input
                      style="width: 676px;"
                      type="textarea"
                      placeholder="请输入"
                      :maxlength="600"
                      v-model.trim="FormData.content"
                      :rows="12"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="list-two-line">
                  <el-form-item label="校友圈公约(英文)">
                    <!-- class="list-textarea" -->
                    <el-input
                      style="width: 676px;"
                      type="textarea"
                      placeholder="不填默认使用中文版内容"
                      :maxlength="1000"
                      v-model.trim="FormData.contentEn"
                      :rows="12"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <div class="phon-right">
        <img class="phon-right-img" src="@/assets/gy.gif" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAlumniContract,
  updateAlumniContract
} from "@/store/appconfig/AlumniPact"; //我的

export default {
  name: "formSeven",
  props: ["IDlist"],
  data() {
    return {
      FormData: "" //初始数据
    };
  },
  created() {
    this.getAlumniContractFN();
  },
  methods: {
    //重置
    Reset() {
      this.getAlumniContractFN();
    },
    //保存
    updateAlumniContractFN() {
      try {
        const params = this.FormData;
        if (params.content === '') return this.$message.error('请填写校友圈公约');
        updateAlumniContract(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.$message.success("操作成功");
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //获取数据
    getAlumniContractFN() {
      try {
        getAlumniContract().then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.FormData = data.result[0];
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    }
    //=========================
  }
};
</script>

<style lang="scss">
.el-textarea .el-textarea__inner {
  // 然后找到对应的类名，在这里将拉伸去掉即可
  resize: none;
}
.phon-right{
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  height:calc(100vh - 102px);
  border-left: 1px solid #dcdee2;
  img{
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;

  }
}
.required .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
</style>
